import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'

const initialState = {
    editingUserId: null,
    showInviteUserDrawer: false,
}

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setEditingUserId: (state, action) => {
            state.editingUserId = action.payload
        },
        setShowInviteUserDrawer: (state, action) => {
            state.showInviteUserDrawer = action.payload
        },
        reset: () => initialState,
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState),
})

export const userActions = userSlice.actions

export default userSlice.reducer
